import {
  Component,
  Input,
  Output,
  EventEmitter,
  OnInit,
} from '@angular/core';

import { Discovery } from 'app/apps/discovery/app/models/discovery.model';
import { Report } from 'app/apps/reports/app/models/report.model';
import { Dashboard } from 'app/apps/studio/app/models/dashboard.model';
import { ObjectBaseService } from '../../services/object-base/object-base.service';
import { SessionService } from '../../services/session/session.service';

@Component({
  selector: 'change-owner-modal',
  templateUrl: './change-owner-modal.component.html',
  styleUrls: ['./change-owner-modal.component.less'],
})
export class ChangeOwnerModalComponent implements OnInit {
  @Input() objectToShare: Report | Dashboard | Discovery;
  @Input() dialogId: string = 'changeOwnerDialog';
  @Output() newOwner = new EventEmitter();

  public accountUsers = [];
  public currentOwner: any;
  public loadingUsers: boolean = false;

  constructor(
    private sessionService: SessionService,
    private objectBaseService: ObjectBaseService,
  ) { }

  ngOnInit() {
    this.loadUsers();
  }

  public changeOwner() {
    this.newOwner.emit(this.currentOwner);
  }

  public setMeAsOwner() {
    this.newOwner.emit(this.sessionService.user);
  }

  private isEmail(string) {
    var regexp = /\S+@\S+\.\S+/;
    return regexp.test(string);
  }

  private loadUsers() {
    this.loadingUsers = true;
    this.objectBaseService.accountUsers().subscribe(users => {
      this.loadingUsers = false;
      this.accountUsers = users;
      this.accountUsers = this.accountUsers.map(user => {
        if (this.isEmail(user.name)) {
          return user;
        } else {
          return { ...user, name: user.name + ' (' + user.email + ')' };
        }
      });
      this.accountUsers = this.accountUsers.unique();
      this.accountUsers = this.accountUsers.sortBy(user => user.name);
      this.currentOwner = this.accountUsers.find(user => user.id === this.objectToShare?.owner);
    });
  }
}
